import RaTreeTranslationMessages from './RaTreeTranslationMessages';

const raTreeEnglishMessages: RaTreeTranslationMessages = {
    'ra-tree': {
        drag_preview:
            'Node #%{id} |||| Node #%{id} with %{smart_count} children',
        root_target: 'Drop an item here to make it top level',
        item_moved: 'Item moved',
        item_created: 'Item created successfully',
        new_node: 'New node',
        action: {
            add_root: 'Add root item',
            add_child: 'Add child item',
        },  
    },
};

export default raTreeEnglishMessages;
